import isEmpty from "lodash/isEmpty";
import { BOTH_INCLUSION_TYPE } from "data-lake/Constants";
import { isValidDate } from "util/DateTime";
export const getDefaultValues = (formatTime, timeRange, dataLakeId, streamIds, defaultFieldFilters = [], defaultFieldOperator = "AND") => {
  const from = (timeRange == null ? void 0 : timeRange.from) || (/* @__PURE__ */ new Date()).setMinutes(0, 0);
  const to = (timeRange == null ? void 0 : timeRange.to) || (/* @__PURE__ */ new Date()).setMinutes(0, 0);
  return {
    inclusionType: BOTH_INCLUSION_TYPE,
    dataLakeId,
    streamIds,
    fieldFilters: defaultFieldFilters,
    operator: defaultFieldOperator,
    nextTimeRange: {
      type: "absolute",
      from: formatTime(from),
      to: formatTime(to)
    }
  };
};
export const getRangeValidationErrors = (from, to) => {
  const formatError = "Format must be: YYYY-MM-DD [HH:mm].";
  const rangeError = 'The "To" date must come after the "From" date.';
  let errors = {};
  if (!from) {
    errors = { ...errors, from: 'The "From" field is required.' };
  }
  if (!to) {
    errors = { ...errors, to: 'The "To" field is required.' };
  }
  if (from && !isValidDate(from) || to && !isValidDate(to)) {
    errors = { ...errors, from: formatError };
  }
  if (from >= to) {
    errors = { ...errors, to: rangeError };
  }
  if (isEmpty(errors)) return {};
  return { nextTimeRange: errors };
};
